/**
 * Customer account helpers
 * - Toggle login / password recovery forms
 * - Manage customer addresses UI helpers
 */

const focusFirstField = (root) => {
  const focusTarget = root?.querySelector('input, select, button')
  if (focusTarget) {
    try {
      focusTarget.focus({ preventScroll: true })
    } catch (error) {
      focusTarget.focus()
    }
  }
}

const toggleAuthView = () => {
  const container = document.querySelector('[data-customer-auth]')
  if (!container) return

  const views = {
    login: container.querySelector('[data-auth-view="login"]'),
    recover: container.querySelector('[data-auth-view="recover"]'),
  }

  container.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-auth-switch]')
    if (!trigger) return

    event.preventDefault()
    const target = trigger.getAttribute('data-auth-switch')

    Object.entries(views).forEach(([key, view]) => {
      if (!view) return
      if (key === target) {
        view.removeAttribute('hidden')
        view.classList.remove('hidden')
      } else {
        view.setAttribute('hidden', 'hidden')
        view.classList.add('hidden')
      }
    })

    focusFirstField(views[target])
  })
}

const toggleFormVisibility = (form, forceOpen) => {
  if (!form) return
  const isCurrentlyHidden =
    form.classList.contains('hidden') || form.hasAttribute('hidden')
  const shouldShow =
    typeof forceOpen === 'boolean' ? forceOpen : isCurrentlyHidden

  if (shouldShow) {
    form.classList.remove('hidden')
    form.removeAttribute('hidden')
    focusFirstField(form)
  } else {
    form.classList.add('hidden')
    form.setAttribute('hidden', 'hidden')
  }
}

const parseProvinceData = (option) => {
  if (!option) return []

  const raw = option.getAttribute('data-provinces')
  if (!raw || raw === '[]') return []

  try {
    const normalized = raw
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
    const placeholder = normalized.replace(/\\'/g, '__SQUOTE__')
    const jsonReady = placeholder.replace(/'/g, '"')
    const restored = jsonReady.replace(/__SQUOTE__/g, "'")
    const provinces = JSON.parse(restored)
    return Array.isArray(provinces) ? provinces : []
  } catch (error) {
    console.warn('Failed to parse provinces for option', option.value, error)
    return []
  }
}

const syncProvinceOptions = (countrySelect, provinceSelect) => {
  if (!countrySelect || !provinceSelect) return

  const countryOption = countrySelect.options[countrySelect.selectedIndex]
  const provinces = parseProvinceData(countryOption)

  const currentValue = provinceSelect.value
  provinceSelect.innerHTML = ''

  const wrapper = provinceSelect.closest('[data-address-province-wrapper]')

  if (provinces.length === 0) {
    provinceSelect.value = ''
    provinceSelect.removeAttribute('required')
    if (wrapper) {
      wrapper.classList.add('hidden')
      wrapper.setAttribute('hidden', 'hidden')
    }
    return
  }

  provinces.forEach(([label, value]) => {
    const option = document.createElement('option')
    option.value = value || label
    option.textContent = label
    provinceSelect.appendChild(option)
  })

  const defaultValue = provinceSelect.getAttribute('data-default')
  const targetValue = currentValue || defaultValue
  if (targetValue) {
    provinceSelect.value = targetValue
    if (provinceSelect.value !== targetValue) {
      provinceSelect.selectedIndex = -1
    }
  }

  provinceSelect.setAttribute('required', 'required')
  if (wrapper) {
    wrapper.classList.remove('hidden')
    wrapper.removeAttribute('hidden')
  }
}

const initAddresses = () => {
  const wrapper = document.querySelector('[data-addresses]')
  if (!wrapper) return

  const deleteMessage =
    wrapper.dataset.deleteConfirm ||
    'Are you sure you want to delete this address?'

  wrapper.addEventListener('click', (event) => {
    const toggleButton = event.target.closest('[data-address-toggle]')
    if (!toggleButton) return

    event.preventDefault()
    const targetId = toggleButton.dataset.addressToggle
    const targetForm = wrapper.querySelector(
      `[data-address-form="${targetId}"]`,
    )
    toggleFormVisibility(targetForm)
  })

  wrapper.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-confirm-delete]')
    if (!form) return

    if (!window.confirm(deleteMessage)) {
      event.preventDefault()
    }
  })

  wrapper.querySelectorAll('form').forEach((form) => {
    const country = form.querySelector('[data-address-country]')
    const province = form.querySelector('[data-address-province]')
    if (!country || !province) return

    syncProvinceOptions(country, province)
    country.addEventListener('change', () => syncProvinceOptions(country, province))
  })

  wrapper.querySelectorAll('[data-address-form]').forEach((form) => {
    if (form.querySelector('.address-errors')) {
      toggleFormVisibility(form, true)
    }
  })
}

const initCustomerAccounts = () => {
  toggleAuthView()
  initAddresses()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomerAccounts, {
    once: true,
  })
} else {
  initCustomerAccounts()
}
